import { NGXLogger, NgxLoggerLevel } from "ngx-logger";
import { AppSettings } from "src/app/app.settings";
import { Constants } from '../constants';

export default class UIHelper {
    static scrollToTop() {
        let scrollToTop = window.setInterval(() => {
            let pos = window.pageYOffset;
            if (pos > 0) {
                window.scrollTo(0, pos - 40); // how far to scroll on each step
            } else {
                window.clearInterval(scrollToTop);
            }
        }, 16);
    }
    static scrollToBottom(pixelsToscroll?: number) {
        if(!pixelsToscroll)
        {
            pixelsToscroll = 300;
        }
        let pos = window.pageYOffset;
        window.scrollTo(0, pos + pixelsToscroll); // how far to scroll on each step
    }

    static supplierDisplayCell(code: string, name: string)
    {
        return  name + " (" + code + ")" ;
    }
    static sourceTypeDisplayCell(name: string, description: string)
    {
        return  description + " (" + name + ")" ;
    }
    static updateLoggerConfig(appSettings: AppSettings, logger: NGXLogger)
    {
        if(logger && appSettings)
        {
            logger.updateConfig({
            enableSourceMaps: true,
            level: appSettings.ENV == 'DEV' ? NgxLoggerLevel.DEBUG : NgxLoggerLevel.OFF
        })
        }
    }

    static DownloadExcelFile(dataBase64: string, filename: string) {
        // convert base64 to ArrayBuffer
        const binaryarr = window.atob(dataBase64);
        const bytes = new Uint8Array(binaryarr.length);

        for (let i = 0; i < binaryarr.length; i++) {
            bytes[i] = binaryarr.charCodeAt(i);
        }
        // create an excel Blob object
        const excelFile = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        // download file
        const fileURL = window.URL.createObjectURL(excelFile);

        // download via a hidden link so we can specify filename
        const tempLink = document.createElement('a') as HTMLAnchorElement;
        tempLink.href = fileURL;
        tempLink.download = filename;
        tempLink.style.display = 'none';
        document.body.appendChild(tempLink);
        tempLink.click();
        tempLink.remove();
    }

    /*
    TMS-17416 Utility function which will find htmlDOM for
    default class-name content and set scrollTop for that dom to 0
    for re-directing to the top of page
    */
    static ScrollToTopForDivContent(className: string = Constants.DefaultClassName) {
        const htmlDOM = document.getElementsByClassName(className);
        if (htmlDOM.length > 0) {
            htmlDOM[0].scrollTop = 0;
        }
    }
}

